import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class UserTableProfileService extends CrudService {
  constructor() {
    super(API_RESOURCE.USER_TABLE_PROFILE)
  }

  addAndCreateTableProfile = async ({ id, ...data }) => {
    const response = await axios.post(`${this.resource}/${id}/profiles`, data)

    return response.data
  }

  getMyTableProfiles = async ({ tableType }) => {
    const response = await axios.get(`${this.resource}/my/${tableType}`)

    return response.data
  }

  deleteTableProfile = async ({ id, tableProfileId }) => {
    const response = await axios.delete(`${this.resource}/${id}/profiles/${tableProfileId}`)

    return response.data
  }

  toggleShownProfileInSidebar = async ({ id, tableProfileId }) => {
    const response = await axios.put(`${this.resource}/${id}/profiles/${tableProfileId}/toggle-shown-in-sidebar`)

    return response.data
  }
  makeDefaultProfile = async ({ id, tableProfileId }) => {
    const response = await axios.put(`${this.resource}/${id}/profiles/${tableProfileId}/make-default`)

    return response.data
  }
}

export default UserTableProfileService
